import { HEX_COLORS as t, RATING_COLOR as r, convertToGradient as e, generateMainColorObject as g, EMERALD_COLOR as a, SLATE_COLOR as n, PRIMARY_COLOR as i, DANGER_COLOR as h, WARNING_COLOR as l, SUCCESS_COLOR as d, SECONDARY_COLOR as o, convertToRgba as c } from "../colors.js";
const b = {
  colors: {
    theme: {
      ...g(t.white),
      gradient: e(t.white),
      backgroundTheme: "linear-gradient(135deg, rgba(230,241,247,1) 0%, rgba(243,243,252,1) 25%, rgba(246,244,241,1) 50%, rgba(246,242,236,1) 75%, rgba(246,248,252,1) 100%)",
      background: t.white,
      text: t.white,
      textOnBackground: t.blackberry
    },
    overlay: c(t.overlay, 0.75),
    default: {
      ...g(t.blackberry, "light", !0),
      gradient: e(t.blackberry),
      background: t.blackberry,
      text: t.blackberry,
      textOnBackground: t.white
    },
    primary: {
      ...g(i.light),
      gradient: e(i.light),
      background: i.light,
      text: i.light,
      textOnBackground: t.white
    },
    secondary: {
      ...g(o.light),
      gradient: e(o.light),
      background: o.light,
      text: o.light,
      textOnBackground: t.white
    },
    success: {
      ...g(d.light),
      gradient: e(d.light),
      background: d.light,
      text: d.light,
      textOnBackground: t.white
    },
    warning: {
      ...g(l.light),
      gradient: e(l.light),
      background: l.light,
      text: l.light,
      textOnBackground: t.white
    },
    danger: {
      ...g(h.light),
      gradient: e(h.light),
      background: h.light,
      text: h.light,
      textOnBackground: t.white
    },
    info: {
      ...g(t.white),
      gradient: e(t.white),
      background: t.white,
      text: t.white,
      textOnBackground: i.light,
      backgroundHovered: i.light
    },
    // Used for AI
    slate: {
      ...g(n.light),
      gradient: e(n.light),
      background: n.light,
      text: n.light,
      textOnBackground: t.white
    },
    emerald: {
      ...g(a.light),
      gradient: e(a.light),
      background: a.light,
      text: a.light,
      textOnBackground: t.white
    },
    ratings: {
      ...g(r.light),
      gradient: e(r.light),
      background: r.light,
      text: r.light,
      textOnBackground: t.white
    }
  }
};
export {
  b as lightTheme
};
